<template lang="pug">
  .component-backoffice-policy-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false")
</template>

<script type="text/babel">
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import BaseList from './BaseList'


    export default {
        name: 'PolicyList',
        components: {
            BaseList,
        },
        data: function () {
            return {
                component: require('src/components/backoffice/Policy.vue'),
            }
        },
        created() {
            this.dataLoader()
        },
        methods: {
            dataLoader(callback, page, resultsPerPage) {
                KeplerBackofficeSdk.policies.list(page, resultsPerPage).all((data) => {
                    console.log(data)
                    callback(data)
                })
            },

        },
    }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PolicyList.vue?f1a9f9ce